import React from 'react';

export const PlaceholderPanel = ({ item, prefix, open, selectedKey, toggle, keyFor }) => {
    const key = keyFor(prefix, item);
    const isOpen = !!open[key];

    return (
        <li key={key} className={'in-context-menu-item' + (selectedKey === item.key ? ' is-selected' : '')}>
            <div className="in-context-menu-label">
                <button
                    type="button"
                    className="in-context-menu-button"
                    onClick={() => toggle(key)}
                >
                    {item.name}
                </button>
                <button
                    type="button"
                    className="in-context-toggle"
                    onClick={() => toggle(key)}
                    aria-label={isOpen ? 'Collapse' : 'Expand'}
                >
                    {isOpen ?
                        <i className="spark-icon-arrow-chevron-down spark-icon--fill" /> :
                        <i className="spark-icon-arrow-chevron-up spark-icon--fill" />
                    }
                </button>
            </div>
            <div className={'in-context-submenu' + (isOpen ? ' open' : '')}>
                <div className="in-context-placeholder">
                    <div className="in-context-placeholder-title">{item.name}</div>
                    <div className="in-context-placeholder-desc">Settings will appear here.</div>
                </div>
            </div>
        </li>
    );
};


// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/panels/PlaceholderPanel.js